/* eslint-disable no-unused-vars */
import React from 'react';
import Iframe from 'react-iframe'

const Searchsection = () => {
  return (
    <>
      <Iframe url="https://www.sitekitpro.krycloud.in/search-2/"
         width="100%"
         height="600px" 
         display="block"
         position="relative" scrolling="no" overflow-y="hidden" /> 
    </>
  );
}

export default Searchsection;
